export default "__VITE_ASSET__hggx737f__"